import { useCallback, ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from 'antd';

import { ConfirmDeleteModal, DeleteErrorException } from '@ohpen/enso-ui';
import { OhpenValidationError, NoteResponse, ActionEntityType, notesDeleteNote } from '@pmp/api';
import { DeleteModalProps } from '@pmp/types';

const { Text } = Typography;
export const NotesDeleteModal = ({ open, record, onClose, refreshTable }: DeleteModalProps<NoteResponse>): ReactElement => {
  const { t } = useTranslation();

  const onConfirmDelete = useCallback(() => {
    return record?.entityId && record?.entityType
      ? notesDeleteNote({
          path: { noteId: record.id },
          query: { entityId: record.entityId, entityType: record.entityType as unknown as ActionEntityType },
        })
          .then(() => {
            onClose();
            refreshTable();
            return { description: t('global.notifications.xDeletedSuccessfully', { x: t('lender.firms.labels.notes') }) };
          })
          .catch((error: { response: { data: OhpenValidationError } }) => {
            onClose();
            return Promise.reject(new DeleteErrorException(error.response.data['invalid-params']?.[0].reason ?? ''));
          })
      : Promise.reject(new DeleteErrorException(t('global.errors.invalidRecord')));
  }, [onClose, record, refreshTable, t]);
  return (
    <ConfirmDeleteModal
      title={t('global.labels.deleteX', { x: t('lender.firms.labels.notes') })}
      open={open}
      onConfirm={onConfirmDelete}
      onCancel={onClose}
    >
      <Text>
        <Trans i18nKey="global.labels.confirmDeleteX" values={{ x: record?.entityId }} components={{ italic: <i /> }} />
      </Text>
    </ConfirmDeleteModal>
  );
};
